import { render, staticRenderFns } from "./TrainingPlanUpdateForm.vue?vue&type=template&id=323f6e6d&scoped=true&"
import script from "./TrainingPlanUpdateForm.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanUpdateForm.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanUpdateForm.vue?vue&type=style&index=0&id=323f6e6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f6e6d",
  null
  
)

export default component.exports